import React from 'react'
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import AccountManageModal from './AccountManageModal';

export default class PaymentInfo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            accountListModalShow: false
        }
    }

    render() {
        const {action, paymentInfo, onChange, disabled, isEPayment, onAddAccount, onChangeAccount, onDeleteAccount} = this.props;
        const {accountListModalShow} = this.state;
        return (
            <React.Fragment>
                <Row>
                    <Col sm={12} className="font-weight-bold">
                        Payment Information
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col sm={12}>
                        <Row>                    
                            <Col sm={6}>
                                <Form.Group controlId="accountNo">
                                    <Form.Label className="text-grey font-weight-bold medium required">Bank Account Number</Form.Label>
                                    <InputGroup>                                
                                        <Form.Control
                                            name="accountNo" type="text" placeholder="Enter account number"
                                            pattern="\d{10}"
                                            maxLength="10"
                                            title="Account number must be 10 digits only"
                                            value={paymentInfo ? paymentInfo.accountList[0] : ''}
                                            onChange={(e) => onChangeAccount(0, e.target.value, "NUMERIC")}
                                            disabled={disabled}
                                            required
                                        />
                                        <InputGroup.Append>
                                            <Button block variant="secondary" onClick={()=>{this.setState({accountListModalShow:true})}}
                                                disabled={action === "create" ? disabled : false}>
                                                <FontAwesomeIcon size="lg" icon={faEllipsisH}/>
                                            </Button>
                                        </InputGroup.Append>
                                    </InputGroup>
                                    
                                    <AccountManageModal 
                                        show={accountListModalShow}
                                        onClose={()=>{this.setState({accountListModalShow:false})}}
                                        accountList = {paymentInfo.accountList}
                                    />
                                </Form.Group>
                            </Col>                 
                            <Col sm={6}>
                                <Form.Group controlId="merchantCustomerId">
                                    <Form.Label className="text-grey font-weight-bold medium">Merchant's Customer ID</Form.Label>
                                    <Form.Control
                                        name="merchantCustomerId" type="text"
                                        placeholder="Enter merchant's customer ID"
                                        disabled={disabled || action !== 'create'}
                                        maxLength={25}  
                                        onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                        value={paymentInfo ? paymentInfo.merchantCustomerId : ''}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>                             
                            <Col sm={6}>
                                <Form.Group controlId="paymentChannel">
                                    <Form.Label className="text-grey font-weight-bold medium">Customer Payment Channel</Form.Label>
                                    <Form.Control
                                        name="regisChanpaymentChannelnel" type="text"
                                        placeholder="Enter customer payment channel"
                                        disabled={true}
                                        onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                        value={paymentInfo ? paymentInfo.paymentChannel : ''}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group controlId="regisChannel">
                                    <Form.Label className="text-grey font-weight-bold medium">Customer Registration Channel</Form.Label>
                                    <Form.Control
                                        name="regisChannel" type="text"
                                        placeholder="Enter customer registration channel"
                                        disabled={true}
                                        onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                        value={paymentInfo ? paymentInfo.regisChannel : ''}
                                    />
                                </Form.Group>
                            </Col>                     
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <Form.Group controlId="prefix">
                                    <Form.Label className="text-grey font-weight-bold medium required">Setup User ID</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Prepend>
                                            <Form.Control 
                                                as="select" 
                                                name="prefix" 
                                                onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                                value={paymentInfo ? paymentInfo.prefix : ''} 
                                                disabled={disabled || !isEPayment || action !== 'create'}
                                                >
                                                <option value="">Select</option>
                                                <option value="RD">RD</option>
                                                <option value="SSO">SSO</option>
                                            </Form.Control>
                                        </InputGroup.Prepend>
                                        <Form.Control
                                            name="userId" type="text"
                                            placeholder="Enter user ID"
                                            disabled={disabled || !isEPayment || action !== 'create'}
                                            onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                            value={paymentInfo ? paymentInfo.userId : ''}
                                            required
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group controlId="prefix">
                                    <Form.Label className="text-grey font-weight-bold medium">User ID for E-Payment User</Form.Label>
                                    <Form.Row>
                                        <Col className="pt-2 text-grey">
                                            {paymentInfo.userId === "" ? "-" : paymentInfo.prefix + paymentInfo.userId}
                                        </Col>
                                    </Form.Row>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                    
                </Row>
            </React.Fragment>
        )
    }
}
